module.exports = __webpack_public_path__ + "ForSaleSign-11A5UuG.svg";